import { combineReducers } from 'redux';
import agents from './agents';
import agentDetail from './agentDetail';
import session from './session';
import reviewForm from './reviewForm';
import { penderReducer as pender } from 'redux-pender';

export default combineReducers({
  agents,
  agentDetail,
  session,
  reviewForm,
  pender,
});



// WEBPACK FOOTER //
// ./src/store/modules/index.js